<script setup>
import { usePage } from '@inertiajs/vue3';
import { computed, getCurrentInstance } from 'vue';
import Message from 'primevue/message';

const { proxy } = getCurrentInstance();
const $t = proxy.$t;

const page = usePage();
const isActive = computed(() => page.props.marketplaceSyncActive);
</script>

<template>
    <Message v-if="isActive" severity="info" :closable="false" class="mb-4">
        {{ $t('We are updating our database, you may experience variations.') }}
    </Message>
</template>
